export function camelToSnakeCase(s) {
    return s.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
export function snakeToCamelCase(s) {
    return s
        .toLowerCase()
        .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
}
export function uncapitalize(s) {
    return (s.charAt(0).toLowerCase() + s.slice(1));
}
export function capitalize(s) {
    return (s.charAt(0).toUpperCase() + s.slice(1));
}
export function toLowerCase(s) {
    return s.toLowerCase();
}
export function toUpperCase(s) {
    return s.toUpperCase();
}
export function format(s, ...args) {
    for (const arg of args) {
        s = s.replace('{}', String(arg));
    }
    return s;
}
